import actionTypes from './ActionTypes';
import actionTypesProfile from '../Profile/ActionTypes';
import request from '../../utils/request';
import apiSettings from '../../config/api';
import {getLocalStorage, setLocalStorage} from "../../utils/storage";
import routerConfig from "../../config/router";


const showLogin = () => {
  return dispatch => {
    dispatch({type: actionTypes.SHOW_LOGIN})
  }
};

const showRegister = () => {
  return dispatch => {
    dispatch({type: actionTypes.SHOW_REGISTER})
  }
};

const showResetPassword = (email) => {
  return dispatch => {
    dispatch({type: actionTypes.SHOW_RESET_PASSWORD, data: email})
  }
};

const hideAll = () => {
  return dispatch => {
    dispatch({type: actionTypes.HIDE})
  }
};

const submitRegister = (data, history) => {
  const url = apiSettings.endpoints.genRegisterUrl();
  return dispatch => {
    return request
      .post(url, data, dispatch, actionTypes.REGISTER)
      .then(() => {
        if (history)
          history.push(routerConfig.home);
        dispatch({type: actionTypes.REGISTER.fulfilled, registerEmail: data.email});
        return true;
      })
  }
};

const getUserInfo = () => {
  const url = apiSettings.endpoints.genGetUserInfoUrl();
  const isAuthorized = getLocalStorage('isAuthorised');

  return dispatch => {
    if (isAuthorized)
      return request
        .get(url, dispatch, actionTypes.GET_USER_INFO)
        .then((res) => {
          dispatch({type: actionTypes.GET_USER_INFO.fulfilled, data: res.data});
          dispatch({type: actionTypesProfile.GET_USER_DATA_FOR_EDIT, data: res.data});
          return true;
        });
    return dispatch({type: actionTypes.GET_USER_INFO.rejected})
  }
};

const submitLogin = (data) => {
  const url = apiSettings.endpoints.genLoginUrl();
  return dispatch => {
    return request
      .post(url, data, dispatch, actionTypes.LOGIN)
      .then((res) => {
        if (res.data.isAdmin) {
          setLocalStorage('isAuthorised', 'true');
          window.location.href = '/admin'
        } else {
          dispatch({type: actionTypes.LOGIN.fulfilled, data: res.data});
          dispatch(getUserInfo());
        }
      })
  }
};

const submitLogout = () => {
  const url = apiSettings.endpoints.genLogoutUrl();
  return dispatch => {
    return request
      .post(url, {}, dispatch, actionTypes.LOGOUT)
      .then(() => {
        dispatch({type: actionTypes.LOGOUT.fulfilled});
        return true;
      })
  }
};

const resetPasswordSendEmail = (data) => {
  const url = apiSettings.endpoints.genResetPasswordSendEmailUrl();
  return dispatch => {
    return request
      .post(url, data, dispatch, actionTypes.RESET_PASSWORD_SEND_EMAIL)
      .then(() => {
        dispatch({type: actionTypes.RESET_PASSWORD_SEND_EMAIL.fulfilled});
        return true;
      })
  }
};

const resetPasswordCheckHash = (data) => {
  const url = apiSettings.endpoints.genResetCheckHashUrl();
  return dispatch => {
    return request
      .post(url, data, dispatch, actionTypes.RESET_PASSWORD_CHECK_HASH)
      .then(() => {
        dispatch({type: actionTypes.RESET_PASSWORD_CHECK_HASH.fulfilled});
        return true;
      })
  }
};

const resetPasswordConfirm = (data, history) => {
  const url = apiSettings.endpoints.genResetPasswordConfirmUrl();
  return dispatch => {
    return request
      .post(url, data, dispatch, actionTypes.RESET_PASSWORD_CONFIRM)
      .then(() => {
        history.replace(routerConfig.home);
        dispatch({type: actionTypes.RESET_PASSWORD_CONFIRM.fulfilled});
        return true;
      })
  }
};

export {
  showLogin,
  showRegister,
  hideAll,
  submitRegister,
  submitLogin,
  submitLogout,
  getUserInfo,
  showResetPassword,
  resetPasswordSendEmail,
  resetPasswordCheckHash,
  resetPasswordConfirm
};


// WEBPACK FOOTER //
// ./src/app/containers/Auth/Actions.js